// src/hooks/programs/useExportProgramToPdf.js
import { useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { exportProgramToPdf } from "../../api/apiPrograms";
import parseError from "../../utils/parseError";

const useExportProgramToPdf = () => {
    const {
        mutate: exportPdfMutate,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: ({ id, data }) => exportProgramToPdf(id, data),
        onSuccess: (response, variables) => {
            // Create blob link to download
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', variables.data.filename || 'program.pdf');
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            toast.success("PDF exported successfully");
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to export PDF");
        },
    });

    return {
        exportPdfMutate,
        isPending: isPending || isLoading,
    };
};

export default useExportProgramToPdf;
